// extracted by mini-css-extract-plugin
export var addressFields = "_on-0";
export var animationContainer = "_on-1";
export var footer = "_on-2";
export var lineItems = "_on-3";
export var modalContent = "_on-4";
export var orderName = "_on-5";
export var strong = "_on-6";
export var warning = "_on-7";